import React, { createContext, useContext, useEffect, useState } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  es: {
    translation: {
      // Navigation
      home: 'Inicio',
      back: 'Atrás',
      settings: 'Ajustes',
      contact: 'Contacto',
      logout: 'Cerrar sesión',
      
      // Main content
      mainTitle: 'Impulsá tu contenido con inteligencia artificial.',
      mainSubtitle: 'Zeta AI automatiza tus procesos de publicación y optimiza tu presencia digital.',
      myFile: 'Mi archivo',
      generateWithAI: 'Generar con IA',
      publishWithAI: 'Publicar con IA',
      firstTime: '¿Es tu primera vez usando Zeta AI? Mirá nuestra demo y empezá a crecer con nosotros.',
      watchDemo: 'Ver demo',
      
      // My File
      uploadToMyFile: 'Subir a mi archivo',
      manageMyFile: 'Gestionar mi archivo',
      myCatalog: 'Mi catálogo',
      myAIVideos: 'Mis videos IA',
      
      // Generate with AI
      generateImageWithAI: 'Generar imagen con IA',
      generateVideoWithAI: 'Generar video con IA',
      
      // Publish with AI
      publishToTiendaNube: 'Publicar en Tienda Nube',
      publishToInstagram: 'Publicar en Instagram',
      
      // Settings
      lightDarkMode: 'Modo claro/oscuro',
      language: 'Idioma',
      termsAndConditions: 'Términos y condiciones',
      version: 'Zeta AI v1.0',
      patchNotes: 'Notas del parche',
      themeOn: 'Modo oscuro activado',
      themeOff: 'Modo claro activado',
      loginDescription: 'Ingresar a tu cuenta',
      logoutDescription: 'Cerrar sesión de tu cuenta',
      downloadTerms: 'Descargar términos y condiciones',
      
      // Common
      loading: 'Cargando...',
      uploading: 'Subiendo...',
      error: 'Error',
      success: 'Éxito',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      loginTitle: 'Iniciar sesión',
      loginSubtitle: 'Ingresá con tu cuenta para continuar',
      loginWithGoogle: 'Iniciar con Google',
      email: 'Email',
      password: 'Contraseña',
      emailPlaceholder: 'tu@correo.com',
      passwordPlaceholder: '••••••••',
      or: 'o',
      contactUsCTA: '¿No trabajás con nosotros? ¡Contactános!',
      loginToContinue: 'Iniciar sesión para continuar',
      loginRequiredMessage: 'Debés iniciar sesión para acceder a esta funcionalidad.',
      
      // File upload
      dragAndDrop: 'Arrastra y suelta archivos aquí',
      selectFiles: 'Seleccionar archivos',
      maxSize: 'Tamaño máximo: 10MB',
      supportedFormats: 'Formatos soportados: JPG, PNG, GIF, WebP',
      frontImage: 'Imagen de frente',
      backImage: 'Imagen de revés',
      closeUpImages: 'Imágenes Close Up (4)',
      productName: 'Nombre del producto',
      variants: 'Variantes',
      requiredVariant: 'Variante obligatoria',
      optionalVariants: 'Variantes opcionales (9)',
      productColor: 'Color del modelo',
      
      // Modals
      confirmLogout: '¿Estás seguro que quieres cerrar sesión?',
      selectLanguage: 'Seleccionar idioma',
      spanish: 'Español',
      portuguese: 'Portugués',
      english: 'English',
      currentLanguage: 'Idioma actual',
      
      // Account linking
      accountLinkedWithGoogle: '¡Cuenta vinculada con Google!',
      canLoginWithAnyMethod: 'Ya podés ingresar con cualquier método',
      linkingAccount: 'Vinculando...',
      connectWithGoogle: 'Conectar con Google',
      linkGoogleAccountDescription: 'Vinculá tu cuenta de Google para acceder con ambos métodos',
      errorLinkingAccount: 'Error al vincular cuenta',
      
      // Home page
      manageMyCatalog: 'Gestionar mi catálogo',
      
      // My File page
      myImages: 'Mis imágenes',
      myImagesDescription: 'Visualiza, descarga y gestiona todas tus imágenes organizadas por categorías.',
      myAIModels: 'Mis modelos IA',
      myAIModelsDescription: 'Visualiza, descarga y gestiona todas tus modelos generadas con IA.',
      
      // Generate with AI page
      generateModelWithAI: 'Generar modelo con IA',
      generateModelWithAIDescription: 'Selecciona prendas de tu galería y genera modelos únicos vistiendo tus productos con IA.',
      generateVideoWithAIDescription: 'Selecciona una imagen de tus modelos IA y genera videos dinámicos con IA.',
      
      // Catalog Management page
      catalogManagement: 'Gestión de Catálogo',
      catalogManagementDescription: 'Administra tu inventario de productos de manera eficiente',
      connectedAs: 'Conectado como',
      products: 'Productos',
      productsDescription: 'Gestiona tu inventario de productos',
      categories: 'Categorías',
      categoriesDescription: 'Organiza tus productos por categorías',
      brands: 'Marcas',
      brandsDescription: 'Administra las marcas de tus productos',
      suppliers: 'Proveedores',
      suppliersDescription: 'Gestiona tus proveedores',
      statistics: 'Estadísticas',
      statisticsDescription: 'Visualiza el estado de tu inventario',
      quickActions: 'Acciones Rápidas',
      addProduct: 'Agregar Producto',
      addProductDescription: 'Nuevo item al inventario',
      configureCategory: 'Configurar Categoría',
      configureCategoryDescription: 'Organizar productos',
      viewStatistics: 'Ver Estadísticas',
      viewStatisticsDescription: 'Estado del inventario',
      
      // Publish with AI page
      ecommercePlatforms: 'Plataformas de E-commerce',
      ecommercePlatformsDescription: 'Publica productos en tus plataformas configuradas',
      socialMedia: 'Redes Sociales',
      socialMediaDescription: 'Publica contenido en tus redes sociales conectadas',
      connected: 'Conectado',
      noPlatformsConfigured: 'No hay plataformas configuradas',
      noPlatformsConfiguredDescription: 'Configura tus plataformas de e-commerce para poder publicar productos',
      manageAccount: 'Gestionar Cuenta',
      
      // Settings page
      manageAccountTitle: 'Gestionar Cuenta',
      manageAccountDescription: 'Configura plataformas, cuentas y tipo de tienda',
      signIn: 'Iniciar sesión',
      signInDescription: 'Conectá tu cuenta para acceder',
      
      // Account Management Modal
      accountManagementTitle: 'Gestionar Cuenta',
      accountManagementSubtitle: 'Configura tus plataformas, cuentas y tipo de tienda',
      ecommerceTab: 'E-commerce',
      socialMediaTab: 'Redes Sociales',
      accountsTab: 'Cuentas',
      storeTab: 'Tienda',
      ecommercePlatformsTitle: 'Plataformas de E-commerce',
      ecommercePlatformsDescriptionModal: 'Activa las plataformas que deseas usar para publicar tus productos',
      platformsReadyForPublishing: 'Plataformas listas para publicar',
      platformsReadyDescription: 'Estas plataformas están completamente configuradas y disponibles en el flujo de publicación con IA',
      platformsPendingConfiguration: 'Plataformas pendientes de configuración',
      platformsPendingDescription: 'Completa la configuración de estas plataformas para poder publicar en ellas',
      needsConfiguration: 'Necesita configuración',
      linkAccount: 'Vincular cuenta',
      unlink: 'Desvincular',
      socialMediaTitle: 'Redes Sociales',
      socialMediaDescriptionModal: 'Activa las redes sociales que deseas usar para publicar contenido',
      socialMediaReady: 'Redes sociales listas',
      socialMediaReadyDescription: 'Estas redes sociales están completamente configuradas y disponibles en el flujo de publicación',
      socialMediaPendingConfiguration: 'Redes sociales pendientes de configuración',
      socialMediaPendingDescription: 'Completa la configuración de estas redes sociales para poder publicar en ellas',
      accountConnectionTitle: 'Conexión de Cuentas',
      accountConnectionDescription: 'Vincula tus cuentas para acceder con múltiples métodos',
      accountLinked: 'Cuenta Vinculada',
      accountLinkedDescription: 'Puedes iniciar sesión con email y Google',
      linkGoogleAccountTitle: 'Vincular Cuenta de Google',
      linkGoogleAccountDescriptionModal: 'Agrega Google como método de inicio de sesión',
      linkingAccountModal: 'Vinculando...',
      linkWithGoogle: 'Vincular con Google',
      signInWithEmail: 'Iniciar Sesión con Email',
      currentAuthenticationMethod: 'Método actual de autenticación',
      signInWithEmailDescription: 'Accede con tu email y contraseña',
      signInWithGoogleTitle: 'Iniciar Sesión con Google',
      signInWithGoogleDescription: 'Accede rápidamente con tu cuenta de Google',
      storeConfigurationTitle: 'Configuración de Tienda',
      storeConfigurationDescription: 'Información sobre tu tipo de tienda configurada',
      storeType: 'Tipo de Tienda',
      currentStoreConfiguration: 'Configuración actual de tu tienda',
      storeSetupDescription: 'Esta configuración se estableció durante el setup inicial de tu tienda',
      noStoreConfiguration: 'No hay configuración de tienda',
      configureStoreFromMain: 'Configura tu tipo de tienda desde la página principal',
      viewIntegrationsDocumentation: 'Ver documentación de integraciones',
      cancelModal: 'Cancelar',
      saveConfiguration: 'Guardar Configuración',
      active: 'activa',
      activePlural: 'activas',
      
      // Publish with AI - Additional translations
      publishToMyStores: 'Publicar en Mis Tiendas',
      publishToMyStoresDescription: 'Publicación masiva en plataformas de e-commerce',
      publishToMyNetworks: 'Publicar en Mis Redes',
      publishToMyNetworksDescription: 'Publicación masiva en redes sociales',
      platformsConnected: 'plataforma conectada',
      platformsConnectedPlural: 'plataformas conectadas',
      networksConnected: 'red conectada',
      networksConnectedPlural: 'redes conectadas',
      connectYourPlatforms: 'Conecta tus plataformas',
      connectYourNetworks: 'Conecta tus redes',
      noPlatformsConnected: 'No tenés plataformas conectadas',
      noStoresConnected: 'No tenés tiendas conectadas',
      noSocialNetworksConnected: 'No tenés redes sociales conectadas',
      connectYourFavoriteStores: 'Conectá tus tiendas favoritas',
      connectYourFavoriteStoresDescription: 'Integra tus plataformas de e-commerce para publicar productos de forma masiva',
      connectYourFavoriteNetworks: 'Conectá tus redes favoritas',
      connectYourFavoriteNetworksDescription: 'Integra tus redes sociales para publicar contenido de forma masiva',
      willBeAvailableSoon: 'estará disponible pronto.',
      
      // Password Reset
      passwordReset: 'Reset de Contraseña',
      emailLabel: 'Email',
      emailPlaceholderPasswordReset: 'tu@email.com',
      sendResetEmail: 'Enviar Email de Reset',
      sending: 'Enviando...',
      backToLogin: 'Volver al Login',
      verifyingResetCode: 'Verificando código de reset...',
      verifyingYourResetCode: 'Verificando tu código de reset de contraseña...',
      noValidResetCodeFound: 'No se encontró código de reset válido en la URL.',
      verifyCode: 'Verificar Código',
      verifiedEmail: 'Email verificado',
      newPassword: 'Nueva Contraseña',
      newPasswordPlaceholder: 'Mínimo 6 caracteres',
      confirmPassword: 'Confirmar Contraseña',
      confirmPasswordPlaceholder: 'Repite tu nueva contraseña',
      updatePassword: 'Actualizar Contraseña',
      updating: 'Actualizando...',
      passwordUpdated: '¡Contraseña Actualizada!',
      passwordUpdatedSuccessfully: 'Tu contraseña ha sido actualizada exitosamente. Ya puedes iniciar sesión con tu nueva contraseña.',
      goToLogin: 'Ir al Login',
      needHelp: '¿Necesitas ayuda?',
      contactSupport: 'Contacta soporte',
      
      // Password Reset Error Messages
      pleaseEnterValidEmail: 'Por favor, ingresá un email válido.',
      resetEmailSent: 'Email de reset enviado. Revisá tu bandeja de entrada y seguí las instrucciones.',
      userNotFound: 'Usuario no existente. Verificá tu email o contactá al equipo de Zeta AI para afiliarte.',
      errorSendingResetEmail: 'Error enviando email de reset. Intenta nuevamente.',
      noValidResetCodeInUrl: 'No se encontró código de reset válido en la URL',
      codeVerifiedSuccessfully: 'Código verificado correctamente. Ahora puedes establecer tu nueva contraseña.',
      resetCodeExpiredOrInvalid: 'El código de reset ha expirado o es inválido. Solicita un nuevo email de reset.',
      resetCodeExpired: 'El código de reset ha expirado. Solicita un nuevo email de reset.',
      errorVerifyingResetCode: 'Error verificando el código de reset. Intenta nuevamente.',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordUpdatedSuccessfullyMessage: '¡Contraseña actualizada exitosamente! Ya puedes iniciar sesión con tu nueva contraseña.',
      passwordTooWeak: 'La contraseña es muy débil. Usa una contraseña más segura.',
      // Publish Modals - Instagram
      searchImagesPlaceholder: 'Buscar imágenes en tu archivo...',
      selectedImages: 'Imágenes seleccionadas',
      imageFileArchive: 'Archivo de imágenes',
      mainImage: 'Principal',
      selectAtLeastOneImage: 'Debes seleccionar al menos una imagen',
      generateContent: 'Generar contenido',
      generatingContent: 'Generando contenido...',
      
      // Publish Modals - Tienda Nube
      selectAtLeastOneProduct: 'Debes seleccionar al menos un producto',
      catalogArchive: 'Archivo del catálogo',
      
      // Publish Modals - General
      selectModel: 'Debes seleccionar un modelo IA',
      
      // Welcome Modal
      generateImagesWithAI: 'Genera imágenes con IA',
      createVideosAutomatically: 'Crea videos automáticamente',
      publishOnSocialNetworks: 'Publica en redes sociales',
      // Mass Publishing E-commerce Modal
      loadingPlatforms: 'Cargando plataformas...',
      loadingAIImages: 'Cargando imágenes IA...',
      generateMoreImagesWithAI: 'Generar más imágenes con IA',
      generateRegenerateImageWithAI: 'Generar/Regenerar imagen con IA',
      generateRegenerateDescriptionWithAI: 'Generar/Regenerar Descripción con IA',
      generating: 'Generando...',
      addCustomTag: 'Agregar etiqueta personalizada',
      selectProductForEcommerce: 'Seleccionar Producto para E-commerce',
      selectProductSubtitle: 'Elige un producto de tu inventario para publicar en tus tiendas',
      selectAtLeastOnePlatform: 'Selecciona al menos una plataforma de e-commerce para continuar con la publicación.',
      successfulPublication: 'Publicación exitosa',
      
      // Product field labels
      neck: 'Cuello:',
      style: 'Estilo:',
      brand: 'Marca:',
      stock: 'Stock:',
      size: 'Talle:',
      season: 'Temporada:',
      type: 'Tipo:',
      price: 'Precio:',
      colors: 'Colores:',
      sizes: 'Tallas:',
      materials: 'Materiales:',
      characteristics: 'Características:',
      
      // Catalog Management Modals - Additional translations
      searchProducts: 'Buscar productos...',
      allCategories: 'Todas las categorías',
      selectCategory: 'Seleccionar categoría',
      productNamePlaceholder: 'Ej: Campera Nike Negra',
      brandPlaceholder: 'Escribir o seleccionar marca',
      supplierPlaceholder: 'Escribir o seleccionar proveedor',
      addVariant: 'Agregar Variante',
      colorPlaceholder: 'Ej: Negro, Azul, Rojo...',
      modelPlaceholder: 'Ej: Modelo A, Talla M...',
      frontalImage: 'Frontal',
      deleteProduct: 'Eliminar Producto',
      
      // Brand Management Modal
      newBrand: 'Nueva Marca',
      brandNamePlaceholder: 'Ej: Nike, Adidas, Puma...',
      brandDescriptionPlaceholder: 'Descripción de la marca...',
      website: 'Website:',
      deleteBrand: 'Eliminar Marca',
      editBrand: 'Editar Marca',
      saveBrand: 'Guardar Marca',
      addBrand: 'Agregar Marca',
      
      // Supplier Management Modal
      newSupplier: 'Nuevo Proveedor',
      supplierNamePlaceholder: 'Ej: Proveedor Textil ABC',
      contactPersonPlaceholder: 'Ej: Juan Pérez',
      addressPlaceholder: 'Av. Corrientes 1234, CABA',
      additionalInfoPlaceholder: 'Información adicional sobre el proveedor...',
      phone: 'Teléfono:',
      address: 'Dirección:',
      deleteSupplier: 'Eliminar Proveedor',
      editSupplier: 'Editar Proveedor',
      saveSupplier: 'Guardar Proveedor',
      addSupplier: 'Agregar Proveedor',
      
      // Additional Product Management Modal translations (unique only)
      setAsMain: 'Establecer como Principal',
      closeup: 'Close-up',
      removeImage: 'Eliminar',
      addVariantButton: 'Agregar Variante',
      addVariantDescription: 'Agrega diferentes colores o modelos con sus respectivas imágenes',
      saveProduct: 'Guardar Producto',
      editProduct: 'Editar Producto',
      productDetails: 'Detalles del Producto',
      images: 'Imágenes',
      noProductsFound: 'No se encontraron productos',
      loadingProducts: 'Cargando productos...',
      
      // Additional hardcoded texts from images
      productManagement: 'Gestión de Productos',
      productInventory: 'Inventario de Productos',
      manageProductCatalog: 'Administra tu catálogo de productos',
      categoryConfiguration: 'Configuración de Categorías',
      availableCategories: 'Categorías Disponibles',
      selectCategoryToConfigure: 'Selecciona una categoría para configurar sus campos',
      fields: 'campos',
      brandManagement: 'Gestión de Marcas',
      myBrands: 'Mis Marcas',
      manageProductBrands: 'Administra las marcas de tus productos',
      noBrandsRegistered: 'No hay marcas registradas',
      addBrandsToOrganize: 'Agrega marcas para organizar mejor tus productos',
      supplierManagement: 'Gestión de Proveedores',
      mySuppliers: 'Mis Proveedores',
      manageSuppliersAndContacts: 'Administra tus proveedores y contactos comerciales',
      noSuppliersRegistered: 'No hay proveedores registrados',
      addSuppliersToManage: 'Agrega proveedores para gestionar tus contactos comerciales',
      inventoryStatistics: 'Estadísticas del Inventario',
      totalProducts: 'Total Productos',
      totalValue: 'Valor Total',
      lowStock: 'Stock Bajo',
      categoriesWithMostInventory: 'Categorías con Mayor Inventario',
      productsWithLowStock: 'Productos con Stock Bajo',
      recentActivity: 'Actividad Reciente',
    }
  },
  pt: {
    translation: {
      // Navigation
      home: 'Início',
      back: 'Voltar',
      settings: 'Configurações',
      contact: 'Contato',
      logout: 'Sair',
      
      // Main content
      mainTitle: 'Impulsione seu conteúdo com inteligência artificial.',
      mainSubtitle: 'Zeta AI automatiza seus processos de publicação e otimiza sua presença digital.',
      myFile: 'Meu arquivo',
      generateWithAI: 'Gerar com IA',
      publishWithAI: 'Publicar com IA',
      firstTime: 'É sua primeira vez usando Zeta AI? Veja nossa demo e comece a crescer conosco.',
      watchDemo: 'Ver demo',
      
      // My File
      uploadToMyFile: 'Enviar para meu arquivo',
      manageMyFile: 'Gerenciar meu arquivo',
      myCatalog: 'Meu catálogo',
      myAIVideos: 'Meus vídeos IA',
      
      // Generate with AI
      generateImageWithAI: 'Gerar imagem com IA',
      generateVideoWithAI: 'Gerar vídeo com IA',
      
      // Publish with AI
      publishToTiendaNube: 'Publicar na Tienda Nube',
      publishToInstagram: 'Publicar no Instagram',
      
      // Settings
      lightDarkMode: 'Modo claro/escuro',
      language: 'Idioma',
      termsAndConditions: 'Termos e condições',
      version: 'Zeta AI v1.0',
      patchNotes: 'Notas da versão',
      themeOn: 'Modo escuro ativado',
      themeOff: 'Modo claro ativado',
      loginDescription: 'Entrar na sua conta',
      logoutDescription: 'Sair da sua conta',
      downloadTerms: 'Baixar termos e condições',
      
      // Common
      loading: 'Carregando...',
      uploading: 'Enviando...',
      error: 'Erro',
      success: 'Sucesso',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Salvar',
      delete: 'Excluir',
      edit: 'Editar',
      close: 'Fechar',
      loginTitle: 'Entrar',
      loginSubtitle: 'Entre com sua conta para continuar',
      loginWithGoogle: 'Entrar com Google',
      email: 'Email',
      password: 'Senha',
      emailPlaceholder: 'voce@exemplo.com',
      passwordPlaceholder: '••••••••',
      or: 'ou',
      contactUsCTA: 'Não trabalha conosco? Entre em contato!',
      loginToContinue: 'Entre para continuar',
      loginRequiredMessage: 'Você precisa entrar para acessar esta funcionalidade.',
      
      // File upload
      dragAndDrop: 'Arraste e solte arquivos aqui',
      selectFiles: 'Selecionar arquivos',
      maxSize: 'Tamanho máximo: 10MB',
      supportedFormats: 'Formatos suportados: JPG, PNG, GIF, WebP',
      frontImage: 'Imagem frontal',
      backImage: 'Imagem traseira',
      closeUpImages: 'Imagens Close Up (4)',
      productName: 'Nome do produto',
      variants: 'Variantes',
      requiredVariant: 'Variante obrigatória',
      optionalVariants: 'Variantes opcionais (9)',
      productColor: 'Cor do modelo',
      
      // Modals
      confirmLogout: 'Tem certeza que deseja sair?',
      selectLanguage: 'Selecionar idioma',
      spanish: 'Español',
      portuguese: 'Português',
      english: 'English',
      currentLanguage: 'Idioma atual',
      
      // Account linking
      accountLinkedWithGoogle: 'Conta vinculada com Google!',
      canLoginWithAnyMethod: 'Já pode entrar com qualquer método',
      linkingAccount: 'Vinculando...',
      connectWithGoogle: 'Conectar com Google',
      linkGoogleAccountDescription: 'Vincule sua conta do Google para acessar com ambos os métodos',
      errorLinkingAccount: 'Erro ao vincular conta',
      
      // Home page
      manageMyCatalog: 'Gerenciar meu catálogo',
      
      // My File page
      myImages: 'Minhas Imagens',
      myImagesDescription: 'Visualize, baixe e gerencie todas as suas imagens organizadas por categorias.',
      myAIModels: 'Meus Modelos IA',
      myAIModelsDescription: 'Visualize, baixe e gerencie todos os seus modelos gerados com IA.',
      
      // Generate with AI page
      generateModelWithAI: 'Gerar modelo com IA',
      generateModelWithAIDescription: 'Selecione peças da sua galeria e gere modelos únicos vestindo seus produtos com IA.',
      generateVideoWithAIDescription: 'Selecione uma imagem dos seus modelos IA e gere vídeos dinâmicos com IA.',
      
      // Catalog Management page
      catalogManagement: 'Gestão de Catálogo',
      catalogManagementDescription: 'Administre seu inventário de produtos de forma eficiente',
      connectedAs: 'Conectado como',
      products: 'Produtos',
      productsDescription: 'Gerencie seu inventário de produtos',
      categories: 'Categorias',
      categoriesDescription: 'Organize seus produtos por categorias',
      brands: 'Marcas',
      brandsDescription: 'Administre as marcas dos seus produtos',
      suppliers: 'Fornecedores',
      suppliersDescription: 'Gerencie seus fornecedores',
      statistics: 'Estatísticas',
      statisticsDescription: 'Visualize o estado do seu inventário',
      quickActions: 'Ações Rápidas',
      addProduct: 'Adicionar Produto',
      addProductDescription: 'Novo item ao inventário',
      configureCategory: 'Configurar Categoria',
      configureCategoryDescription: 'Organizar produtos',
      viewStatistics: 'Ver Estatísticas',
      viewStatisticsDescription: 'Estado do inventário',
      
      // Publish with AI page
      ecommercePlatforms: 'Plataformas de E-commerce',
      ecommercePlatformsDescription: 'Publique produtos nas suas plataformas configuradas',
      socialMedia: 'Redes Sociais',
      socialMediaDescription: 'Publique conteúdo nas suas redes sociais conectadas',
      connected: 'Conectado',
      noPlatformsConfigured: 'Não há plataformas configuradas',
      noPlatformsConfiguredDescription: 'Configure suas plataformas de e-commerce para poder publicar produtos',
      manageAccount: 'Gerenciar Conta',
      
      // Settings page
      manageAccountTitle: 'Gerenciar Conta',
      manageAccountDescription: 'Configure plataformas, contas e tipo de loja',
      signIn: 'Entrar',
      signInDescription: 'Conecte sua conta para acessar',
      
      // Account Management Modal
      accountManagementTitle: 'Gerenciar Conta',
      accountManagementSubtitle: 'Configure suas plataformas, contas e tipo de loja',
      ecommerceTab: 'E-commerce',
      socialMediaTab: 'Redes Sociais',
      accountsTab: 'Contas',
      storeTab: 'Loja',
      ecommercePlatformsTitle: 'Plataformas de E-commerce',
      ecommercePlatformsDescriptionModal: 'Ative as plataformas que deseja usar para publicar seus produtos',
      platformsReadyForPublishing: 'Plataformas prontas para publicação',
      platformsReadyDescription: 'Estas plataformas estão completamente configuradas e disponíveis no fluxo de publicação com IA',
      platformsPendingConfiguration: 'Plataformas pendentes de configuração',
      platformsPendingDescription: 'Complete a configuração dessas plataformas para poder publicar nelas',
      needsConfiguration: 'Precisa de configuração',
      linkAccount: 'Vincular conta',
      unlink: 'Desvincular',
      socialMediaTitle: 'Redes Sociais',
      socialMediaDescriptionModal: 'Ative as redes sociais que deseja usar para publicar conteúdo',
      socialMediaReady: 'Redes sociais prontas',
      socialMediaReadyDescription: 'Estas redes sociais estão completamente configuradas e disponíveis no fluxo de publicação',
      socialMediaPendingConfiguration: 'Redes sociais pendentes de configuração',
      socialMediaPendingDescription: 'Complete a configuração dessas redes sociais para poder publicar nelas',
      accountConnectionTitle: 'Conexão de Contas',
      accountConnectionDescription: 'Vincule suas contas para acessar com múltiplos métodos',
      accountLinked: 'Conta Vinculada',
      accountLinkedDescription: 'Você pode entrar com email e Google',
      linkGoogleAccountTitle: 'Vincular Conta do Google',
      linkGoogleAccountDescriptionModal: 'Adicione Google como método de entrada',
      linkingAccountModal: 'Vinculando...',
      linkWithGoogle: 'Vincular com Google',
      signInWithEmail: 'Entrar com Email',
      currentAuthenticationMethod: 'Método atual de autenticação',
      signInWithEmailDescription: 'Acesse com seu email e senha',
      signInWithGoogleTitle: 'Entrar com Google',
      signInWithGoogleDescription: 'Acesse rapidamente com sua conta do Google',
      storeConfigurationTitle: 'Configuração da Loja',
      storeConfigurationDescription: 'Informações sobre seu tipo de loja configurado',
      storeType: 'Tipo de Loja',
      currentStoreConfiguration: 'Configuração atual da sua loja',
      storeSetupDescription: 'Esta configuração foi estabelecida durante a configuração inicial da sua loja',
      noStoreConfiguration: 'Não há configuração de loja',
      configureStoreFromMain: 'Configure seu tipo de loja na página principal',
      viewIntegrationsDocumentation: 'Ver documentação de integrações',
      cancelModal: 'Cancelar',
      saveConfiguration: 'Salvar Configuração',
      active: 'ativa',
      activePlural: 'ativas',
      
      // Publish with AI - Additional translations
      publishToMyStores: 'Publicar nas Minhas Lojas',
      publishToMyStoresDescription: 'Publicação em massa em plataformas de e-commerce',
      publishToMyNetworks: 'Publicar nas Minhas Redes',
      publishToMyNetworksDescription: 'Publicação em massa em redes sociais',
      platformsConnected: 'plataforma conectada',
      platformsConnectedPlural: 'plataformas conectadas',
      networksConnected: 'rede conectada',
      networksConnectedPlural: 'redes conectadas',
      connectYourPlatforms: 'Conecte suas plataformas',
      connectYourNetworks: 'Conecte suas redes',
      noPlatformsConnected: 'Você não tem plataformas conectadas',
      noStoresConnected: 'Você não tem lojas conectadas',
      noSocialNetworksConnected: 'Você não tem redes sociais conectadas',
      connectYourFavoriteStores: 'Conecte suas lojas favoritas',
      connectYourFavoriteStoresDescription: 'Integre suas plataformas de e-commerce para publicar produtos em massa',
      connectYourFavoriteNetworks: 'Conecte suas redes favoritas',
      connectYourFavoriteNetworksDescription: 'Integre suas redes sociais para publicar conteúdo em massa',
      willBeAvailableSoon: 'estará disponível em breve.',
      
      // Password Reset
      passwordReset: 'Redefinir Senha',
      emailLabel: 'Email',
      emailPlaceholderPasswordReset: 'voce@email.com',
      sendResetEmail: 'Enviar Email de Redefinição',
      sending: 'Enviando...',
      backToLogin: 'Voltar ao Login',
      verifyingResetCode: 'Verificando código de redefinição...',
      verifyingYourResetCode: 'Verificando seu código de redefinição de senha...',
      noValidResetCodeFound: 'Nenhum código de redefinição válido encontrado na URL.',
      verifyCode: 'Verificar Código',
      verifiedEmail: 'Email verificado',
      newPassword: 'Nova Senha',
      newPasswordPlaceholder: 'Mínimo 6 caracteres',
      confirmPassword: 'Confirmar Senha',
      confirmPasswordPlaceholder: 'Repita sua nova senha',
      updatePassword: 'Atualizar Senha',
      updating: 'Atualizando...',
      passwordUpdated: 'Senha Atualizada!',
      passwordUpdatedSuccessfully: 'Sua senha foi atualizada com sucesso. Agora você pode fazer login com sua nova senha.',
      goToLogin: 'Ir ao Login',
      needHelp: 'Precisa de ajuda?',
      contactSupport: 'Entre em contato com o suporte',
      
      // Password Reset Error Messages
      pleaseEnterValidEmail: 'Por favor, insira um email válido.',
      resetEmailSent: 'Email de redefinição enviado. Verifique sua caixa de entrada e siga as instruções.',
      userNotFound: 'Usuário não encontrado. Verifique seu email ou entre em contato com a equipe Zeta AI para se afiliar.',
      errorSendingResetEmail: 'Erro ao enviar email de redefinição. Tente novamente.',
      noValidResetCodeInUrl: 'Nenhum código de redefinição válido encontrado na URL',
      codeVerifiedSuccessfully: 'Código verificado com sucesso. Agora você pode definir sua nova senha.',
      resetCodeExpiredOrInvalid: 'O código de redefinição expirou ou é inválido. Solicite um novo email de redefinição.',
      resetCodeExpired: 'O código de redefinição expirou. Solicite um novo email de redefinição.',
      errorVerifyingResetCode: 'Erro ao verificar o código de redefinição. Tente novamente.',
      passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
      passwordsDoNotMatch: 'As senhas não coincidem',
      passwordUpdatedSuccessfullyMessage: 'Senha atualizada com sucesso! Agora você pode fazer login com sua nova senha.',
      passwordTooWeak: 'A senha é muito fraca. Use uma senha mais segura.',
      // Publish Modals - Instagram
      searchImagesPlaceholder: 'Buscar imagens no seu arquivo...',
      selectedImages: 'Imagens selecionadas',
      imageFileArchive: 'Arquivo de imagens',
      mainImage: 'Principal',
      selectAtLeastOneImage: 'Você deve selecionar pelo menos uma imagem',
      generateContent: 'Gerar conteúdo',
      generatingContent: 'Gerando conteúdo...',
      
      // Publish Modals - Tienda Nube
      selectAtLeastOneProduct: 'Você deve selecionar pelo menos um produto',
      catalogArchive: 'Arquivo do catálogo',
      
      // Publish Modals - General
      selectModel: 'Você deve selecionar um modelo IA',
      
      // Welcome Modal
      generateImagesWithAI: 'Gere imagens com IA',
      createVideosAutomatically: 'Crie vídeos automaticamente',
      publishOnSocialNetworks: 'Publique em redes sociais',
      // Mass Publishing E-commerce Modal
      loadingPlatforms: 'Carregando plataformas...',
      loadingAIImages: 'Carregando imagens IA...',
      generateMoreImagesWithAI: 'Gerar mais imagens com IA',
      generateRegenerateImageWithAI: 'Gerar/Regenerar imagem com IA',
      generateRegenerateDescriptionWithAI: 'Gerar/Regenerar Descrição com IA',
      generating: 'Gerando...',
      addCustomTag: 'Adicionar etiqueta personalizada',
      selectProductForEcommerce: 'Selecionar Produto para E-commerce',
      selectProductSubtitle: 'Escolha um produto do seu inventário para publicar nas suas lojas',
      selectAtLeastOnePlatform: 'Selecione pelo menos uma plataforma de e-commerce para continuar com a publicação.',
      successfulPublication: 'Publicação bem-sucedida',
      
      // Product field labels
      neck: 'Pescoço:',
      style: 'Estilo:',
      brand: 'Marca:',
      stock: 'Estoque:',
      size: 'Tamanho:',
      season: 'Temporada:',
      type: 'Tipo:',
      price: 'Preço:',
      colors: 'Cores:',
      sizes: 'Tamanhos:',
      materials: 'Materiais:',
      characteristics: 'Características:',
      
      // Catalog Management Modals - Additional translations
      searchProducts: 'Buscar produtos...',
      allCategories: 'Todas as categorias',
      selectCategory: 'Selecionar categoria',
      productNamePlaceholder: 'Ex: Jaqueta Nike Preta',
      brandPlaceholder: 'Escrever ou selecionar marca',
      supplierPlaceholder: 'Escrever ou selecionar fornecedor',
      addVariant: 'Adicionar Variante',
      colorPlaceholder: 'Ex: Preto, Azul, Vermelho...',
      modelPlaceholder: 'Ex: Modelo A, Tamanho M...',
      frontalImage: 'Frontal',
      deleteProduct: 'Excluir Produto',
      
      // Brand Management Modal
      newBrand: 'Nova Marca',
      brandNamePlaceholder: 'Ex: Nike, Adidas, Puma...',
      brandDescriptionPlaceholder: 'Descrição da marca...',
      website: 'Website:',
      deleteBrand: 'Excluir Marca',
      editBrand: 'Editar Marca',
      saveBrand: 'Salvar Marca',
      addBrand: 'Adicionar Marca',
      
      // Supplier Management Modal
      newSupplier: 'Novo Fornecedor',
      supplierNamePlaceholder: 'Ex: Fornecedor Têxtil ABC',
      contactPersonPlaceholder: 'Ex: João Silva',
      addressPlaceholder: 'Av. Paulista 1234, São Paulo',
      additionalInfoPlaceholder: 'Informações adicionais sobre o fornecedor...',
      phone: 'Telefone:',
      address: 'Endereço:',
      deleteSupplier: 'Excluir Fornecedor',
      editSupplier: 'Editar Fornecedor',
      saveSupplier: 'Salvar Fornecedor',
      addSupplier: 'Adicionar Fornecedor',
      
      // Additional Product Management Modal translations (unique only)
      setAsMain: 'Definir como Principal',
      closeup: 'Close-up',
      removeImage: 'Excluir',
      addVariantButton: 'Adicionar Variante',
      addVariantDescription: 'Adicione diferentes cores ou modelos com suas respectivas imagens',
      saveProduct: 'Salvar Produto',
      editProduct: 'Editar Produto',
      productDetails: 'Detalhes do Produto',
      images: 'Imagens',
      noProductsFound: 'Nenhum produto encontrado',
      loadingProducts: 'Carregando produtos...',
      
      // Additional hardcoded texts from images
      productManagement: 'Gestão de Produtos',
      productInventory: 'Inventário de Produtos',
      manageProductCatalog: 'Administre seu catálogo de produtos',
      categoryConfiguration: 'Configuração de Categorias',
      availableCategories: 'Categorias Disponíveis',
      selectCategoryToConfigure: 'Selecione uma categoria para configurar seus campos',
      fields: 'campos',
      brandManagement: 'Gestão de Marcas',
      myBrands: 'Minhas Marcas',
      manageProductBrands: 'Administre as marcas dos seus produtos',
      noBrandsRegistered: 'Nenhuma marca registrada',
      addBrandsToOrganize: 'Adicione marcas para organizar melhor seus produtos',
      supplierManagement: 'Gestão de Fornecedores',
      mySuppliers: 'Meus Fornecedores',
      manageSuppliersAndContacts: 'Administre seus fornecedores e contatos comerciais',
      noSuppliersRegistered: 'Nenhum fornecedor registrado',
      addSuppliersToManage: 'Adicione fornecedores para gerenciar seus contatos comerciais',
      inventoryStatistics: 'Estatísticas do Inventário',
      totalProducts: 'Total de Produtos',
      totalValue: 'Valor Total',
      lowStock: 'Estoque Baixo',
      categoriesWithMostInventory: 'Categorias com Maior Inventário',
      productsWithLowStock: 'Produtos com Estoque Baixo',
      recentActivity: 'Atividade Recente',
    }
  },
  en: {
    translation: {
      // Navigation
      home: 'Home',
      back: 'Back',
      settings: 'Settings',
      contact: 'Contact',
      logout: 'Logout',
      
      // Main content
      mainTitle: 'Boost your content with artificial intelligence.',
      mainSubtitle: 'Zeta AI automates your publishing processes and optimizes your digital presence.',
      myFile: 'My file',
      generateWithAI: 'Generate with AI',
      publishWithAI: 'Publish with AI',
      firstTime: 'Is it your first time using Zeta AI? Watch our demo and start growing with us.',
      watchDemo: 'Watch demo',
      
      // My File
      uploadToMyFile: 'Upload to my file',
      manageMyFile: 'Manage my file',
      myCatalog: 'My catalog',
      myAIVideos: 'My AI videos',
      
      // Generate with AI
      generateImageWithAI: 'Generate image with AI',
      generateVideoWithAI: 'Generate video with AI',
      
      // Publish with AI
      publishToTiendaNube: 'Publish to Tienda Nube',
      publishToInstagram: 'Publish to Instagram',
      
      // Settings
      lightDarkMode: 'Light/dark mode',
      language: 'Language',
      termsAndConditions: 'Terms and conditions',
      version: 'Zeta AI v1.0',
      patchNotes: 'Patch notes',
      themeOn: 'Dark mode enabled',
      themeOff: 'Light mode enabled',
      loginDescription: 'Sign in to your account',
      logoutDescription: 'Sign out of your account',
      downloadTerms: 'Download terms and conditions',
      
      // Common
      loading: 'Loading...',
      uploading: 'Uploading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      loginTitle: 'Sign in',
      loginSubtitle: 'Sign in with your account to continue',
      loginWithGoogle: 'Sign in with Google',
      email: 'Email',
      password: 'Password',
      emailPlaceholder: 'you@example.com',
      passwordPlaceholder: '••••••••',
      or: 'or',
      contactUsCTA: 'Not working with us? Contact us!',
      loginToContinue: 'Sign in to continue',
      loginRequiredMessage: 'You must sign in to access this feature.',
      
      // File upload
      dragAndDrop: 'Drag and drop files here',
      selectFiles: 'Select files',
      maxSize: 'Max size: 10MB',
      supportedFormats: 'Supported formats: JPG, PNG, GIF, WebP',
      frontImage: 'Front image',
      backImage: 'Back image',
      closeUpImages: 'Close Up images (4)',
      productName: 'Product name',
      variants: 'Variants',
      requiredVariant: 'Required variant',
      optionalVariants: 'Optional variants (9)',
      productColor: 'Product color',
      
      // Modals
      confirmLogout: 'Are you sure you want to logout?',
      selectLanguage: 'Select language',
      spanish: 'Español',
      portuguese: 'Português',
      english: 'English',
      currentLanguage: 'Current language',
      
      // Account linking
      accountLinkedWithGoogle: 'Account linked with Google!',
      canLoginWithAnyMethod: 'You can now login with any method',
      linkingAccount: 'Linking...',
      connectWithGoogle: 'Connect with Google',
      linkGoogleAccountDescription: 'Link your Google account to access with both methods',
      errorLinkingAccount: 'Error linking account',
      
      // Home page
      manageMyCatalog: 'Manage my catalog',
      
      // My File page
      myImages: 'My Images',
      myImagesDescription: 'View, download and manage all your images organized by categories.',
      myAIModels: 'My AI Models',
      myAIModelsDescription: 'View, download and manage all your AI-generated models.',
      
      // Generate with AI page
      generateModelWithAI: 'Generate model with AI',
      generateModelWithAIDescription: 'Select garments from your gallery and generate unique models wearing your products with AI.',
      generateVideoWithAIDescription: 'Select an image from your AI models and generate dynamic videos with AI.',
      
      // Catalog Management page
      catalogManagement: 'Catalog Management',
      catalogManagementDescription: 'Manage your product inventory efficiently',
      connectedAs: 'Connected as',
      products: 'Products',
      productsDescription: 'Manage your product inventory',
      categories: 'Categories',
      categoriesDescription: 'Organize your products by categories',
      brands: 'Brands',
      brandsDescription: 'Manage your product brands',
      suppliers: 'Suppliers',
      suppliersDescription: 'Manage your suppliers',
      statistics: 'Statistics',
      statisticsDescription: 'View your inventory status',
      quickActions: 'Quick Actions',
      addProduct: 'Add Product',
      addProductDescription: 'New item to inventory',
      configureCategory: 'Configure Category',
      configureCategoryDescription: 'Organize products',
      viewStatistics: 'View Statistics',
      viewStatisticsDescription: 'Inventory status',
      
      // Publish with AI page
      ecommercePlatforms: 'E-commerce Platforms',
      ecommercePlatformsDescription: 'Publish products on your configured platforms',
      socialMedia: 'Social Media',
      socialMediaDescription: 'Publish content on your connected social networks',
      connected: 'Connected',
      noPlatformsConfigured: 'No platforms configured',
      noPlatformsConfiguredDescription: 'Configure your e-commerce platforms to be able to publish products',
      manageAccount: 'Manage Account',
      
      // Settings page
      manageAccountTitle: 'Manage Account',
      manageAccountDescription: 'Configure platforms, accounts and store type',
      signIn: 'Sign in',
      signInDescription: 'Connect your account to access',
      
      // Account Management Modal
      accountManagementTitle: 'Manage Account',
      accountManagementSubtitle: 'Configure your platforms, accounts and store type',
      ecommerceTab: 'E-commerce',
      socialMediaTab: 'Social Media',
      accountsTab: 'Accounts',
      storeTab: 'Store',
      ecommercePlatformsTitle: 'E-commerce Platforms',
      ecommercePlatformsDescriptionModal: 'Activate the platforms you want to use to publish your products',
      platformsReadyForPublishing: 'Platforms ready for publishing',
      platformsReadyDescription: 'These platforms are fully configured and available in the AI publishing flow',
      platformsPendingConfiguration: 'Platforms pending configuration',
      platformsPendingDescription: 'Complete the configuration of these platforms to be able to publish on them',
      needsConfiguration: 'Needs configuration',
      linkAccount: 'Link account',
      unlink: 'Unlink',
      socialMediaTitle: 'Social Media',
      socialMediaDescriptionModal: 'Activate the social networks you want to use to publish content',
      socialMediaReady: 'Social networks ready',
      socialMediaReadyDescription: 'These social networks are fully configured and available in the publishing flow',
      socialMediaPendingConfiguration: 'Social networks pending configuration',
      socialMediaPendingDescription: 'Complete the configuration of these social networks to be able to publish on them',
      accountConnectionTitle: 'Account Connection',
      accountConnectionDescription: 'Link your accounts to access with multiple methods',
      accountLinked: 'Account Linked',
      accountLinkedDescription: 'You can sign in with email and Google',
      linkGoogleAccountTitle: 'Link Google Account',
      linkGoogleAccountDescriptionModal: 'Add Google as a sign-in method',
      linkingAccountModal: 'Linking...',
      linkWithGoogle: 'Link with Google',
      signInWithEmail: 'Sign in with Email',
      currentAuthenticationMethod: 'Current authentication method',
      signInWithEmailDescription: 'Access with your email and password',
      signInWithGoogleTitle: 'Sign in with Google',
      signInWithGoogleDescription: 'Access quickly with your Google account',
      storeConfigurationTitle: 'Store Configuration',
      storeConfigurationDescription: 'Information about your configured store type',
      storeType: 'Store Type',
      currentStoreConfiguration: 'Current store configuration',
      storeSetupDescription: 'This configuration was established during the initial setup of your store',
      noStoreConfiguration: 'No store configuration',
      configureStoreFromMain: 'Configure your store type from the main page',
      viewIntegrationsDocumentation: 'View integrations documentation',
      cancelModal: 'Cancel',
      saveConfiguration: 'Save Configuration',
      active: 'active',
      activePlural: 'actives',
      
      // Publish with AI - Additional translations
      publishToMyStores: 'Publish to My Stores',
      publishToMyStoresDescription: 'Mass publishing on e-commerce platforms',
      publishToMyNetworks: 'Publish to My Networks',
      publishToMyNetworksDescription: 'Mass publishing on social networks',
      platformsConnected: 'platform connected',
      platformsConnectedPlural: 'platforms connected',
      networksConnected: 'network connected',
      networksConnectedPlural: 'networks connected',
      connectYourPlatforms: 'Connect your platforms',
      connectYourNetworks: 'Connect your networks',
      noPlatformsConnected: 'You have no platforms connected',
      noStoresConnected: 'You have no stores connected',
      noSocialNetworksConnected: 'You have no social networks connected',
      connectYourFavoriteStores: 'Connect your favorite stores',
      connectYourFavoriteStoresDescription: 'Integrate your e-commerce platforms to publish products in bulk',
      connectYourFavoriteNetworks: 'Connect your favorite networks',
      connectYourFavoriteNetworksDescription: 'Integrate your social networks to publish content in bulk',
      willBeAvailableSoon: 'will be available soon.',
      
      // Password Reset
      passwordReset: 'Password Reset',
      emailLabel: 'Email',
      emailPlaceholderPasswordReset: 'you@email.com',
      sendResetEmail: 'Send Reset Email',
      sending: 'Sending...',
      backToLogin: 'Back to Login',
      verifyingResetCode: 'Verifying reset code...',
      verifyingYourResetCode: 'Verifying your password reset code...',
      noValidResetCodeFound: 'No valid reset code found in URL.',
      verifyCode: 'Verify Code',
      verifiedEmail: 'Verified email',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Minimum 6 characters',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Repeat your new password',
      updatePassword: 'Update Password',
      updating: 'Updating...',
      passwordUpdated: 'Password Updated!',
      passwordUpdatedSuccessfully: 'Your password has been successfully updated. You can now sign in with your new password.',
      goToLogin: 'Go to Login',
      needHelp: 'Need help?',
      contactSupport: 'Contact support',
      
      // Password Reset Error Messages
      pleaseEnterValidEmail: 'Please enter a valid email.',
      resetEmailSent: 'Reset email sent. Check your inbox and follow the instructions.',
      userNotFound: 'User not found. Verify your email or contact the Zeta AI team to join.',
      errorSendingResetEmail: 'Error sending reset email. Try again.',
      noValidResetCodeInUrl: 'No valid reset code found in URL',
      codeVerifiedSuccessfully: 'Code verified successfully. You can now set your new password.',
      resetCodeExpiredOrInvalid: 'The reset code has expired or is invalid. Request a new reset email.',
      resetCodeExpired: 'The reset code has expired. Request a new reset email.',
      errorVerifyingResetCode: 'Error verifying the reset code. Try again.',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordUpdatedSuccessfullyMessage: 'Password updated successfully! You can now sign in with your new password.',
      passwordTooWeak: 'Password is too weak. Use a stronger password.',
      // Publish Modals - Instagram
      searchImagesPlaceholder: 'Search images in your file...',
      selectedImages: 'Selected images',
      imageFileArchive: 'Image file archive',
      mainImage: 'Main',
      selectAtLeastOneImage: 'You must select at least one image',
      generateContent: 'Generate content',
      generatingContent: 'Generating content...',
      
      // Publish Modals - Tienda Nube
      selectAtLeastOneProduct: 'You must select at least one product',
      catalogArchive: 'Catalog archive',
      
      // Publish Modals - General
      selectModel: 'You must select an AI model',
      
      // Welcome Modal
      generateImagesWithAI: 'Generate images with AI',
      createVideosAutomatically: 'Create videos automatically',
      publishOnSocialNetworks: 'Publish on social networks',
      // Mass Publishing E-commerce Modal
      loadingPlatforms: 'Loading platforms...',
      loadingAIImages: 'Loading AI images...',
      generateMoreImagesWithAI: 'Generate more images with AI',
      generateRegenerateImageWithAI: 'Generate/Regenerate image with AI',
      generateRegenerateDescriptionWithAI: 'Generate/Regenerate Description with AI',
      generating: 'Generating...',
      addCustomTag: 'Add custom tag',
      selectProductForEcommerce: 'Select Product for E-commerce',
      selectProductSubtitle: 'Choose a product from your inventory to publish to your stores',
      selectAtLeastOnePlatform: 'Select at least one e-commerce platform to continue with publishing.',
      successfulPublication: 'Successful publication',
      
      // Product field labels
      neck: 'Neck:',
      style: 'Style:',
      brand: 'Brand:',
      stock: 'Stock:',
      size: 'Size:',
      season: 'Season:',
      type: 'Type:',
      price: 'Price:',
      colors: 'Colors:',
      sizes: 'Sizes:',
      materials: 'Materials:',
      characteristics: 'Characteristics:',
      
      // Catalog Management Modals - Additional translations
      searchProducts: 'Search products...',
      allCategories: 'All categories',
      selectCategory: 'Select category',
      productNamePlaceholder: 'Ex: Nike Jacket Black',
      brandPlaceholder: 'Write or select brand',
      supplierPlaceholder: 'Write or select supplier',
      addVariant: 'Add Variant',
      colorPlaceholder: 'Ex: Black, Blue, Red...',
      modelPlaceholder: 'Ex: Model A, Size M...',
      frontalImage: 'Front',
      deleteProduct: 'Delete Product',
      
      // Brand Management Modal
      newBrand: 'New Brand',
      brandNamePlaceholder: 'Ex: Nike, Adidas, Puma...',
      brandDescriptionPlaceholder: 'Brand description...',
      website: 'Website:',
      deleteBrand: 'Delete Brand',
      editBrand: 'Edit Brand',
      saveBrand: 'Save Brand',
      addBrand: 'Add Brand',
      
      // Supplier Management Modal
      newSupplier: 'New Supplier',
      supplierNamePlaceholder: 'Ex: Textile Supplier ABC',
      contactPersonPlaceholder: 'Ex: John Smith',
      addressPlaceholder: '123 Main St, New York',
      additionalInfoPlaceholder: 'Additional information about the supplier...',
      phone: 'Phone:',
      address: 'Address:',
      deleteSupplier: 'Delete Supplier',
      editSupplier: 'Edit Supplier',
      saveSupplier: 'Save Supplier',
      addSupplier: 'Add Supplier',
      
      // Additional Product Management Modal translations (unique only)
      setAsMain: 'Set as Main',
      closeup: 'Close-up',
      removeImage: 'Remove',
      addVariantButton: 'Add Variant',
      addVariantDescription: 'Add different colors or models with their respective images',
      saveProduct: 'Save Product',
      editProduct: 'Edit Product',
      productDetails: 'Product Details',
      images: 'Images',
      noProductsFound: 'No products found',
      loadingProducts: 'Loading products...',
      
      // Additional hardcoded texts from images
      productManagement: 'Product Management',
      productInventory: 'Product Inventory',
      manageProductCatalog: 'Manage your product catalog',
      categoryConfiguration: 'Category Configuration',
      availableCategories: 'Available Categories',
      selectCategoryToConfigure: 'Select a category to configure its fields',
      fields: 'fields',
      brandManagement: 'Brand Management',
      myBrands: 'My Brands',
      manageProductBrands: 'Manage your product brands',
      noBrandsRegistered: 'No brands registered',
      addBrandsToOrganize: 'Add brands to better organize your products',
      supplierManagement: 'Supplier Management',
      mySuppliers: 'My Suppliers',
      manageSuppliersAndContacts: 'Manage your suppliers and commercial contacts',
      noSuppliersRegistered: 'No suppliers registered',
      addSuppliersToManage: 'Add suppliers to manage your commercial contacts',
      inventoryStatistics: 'Inventory Statistics',
      totalProducts: 'Total Products',
      totalValue: 'Total Value',
      lowStock: 'Low Stock',
      categoriesWithMostInventory: 'Categories with Most Inventory',
      productsWithLowStock: 'Products with Low Stock',
      recentActivity: 'Recent Activity',
    }
  }
};

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

interface I18nContextType {
  language: string;
  setLanguage: (lang: string) => void;
  t: (key: string) => string;
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('zeta-ai-language') || 'es';
  });

  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('zeta-ai-language', language);
  }, [language]);

  const t = (key: string) => {
    return i18n.t(key);
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
};
